import React, { useEffect } from "react";
import NotFoundIcon from '../assets/barrier-svgrepo-com.svg';

const NotFound = () => {
    const auth = JSON.parse(window.localStorage.getItem('userInfo')) || JSON.parse(window.sessionStorage.getItem('userInfo'));
    useEffect(() => {
        if (!auth) {
            sessionStorage.clear();
            localStorage.clear();
            window.location.href = '/login'; // Replace with your login route
        }
    }, [auth]);

    return (
        <div style={{ textAlign: "center" }}>
            <img
                style={{ width: 100, height: 100, marginTop: 100 }}
                alt="barrier icon"
                src={NotFoundIcon}
            />
            <h2>Access Denied!<br /> Please contact the system admin for assistance.</h2>
            <b>
                Click to return <a href="/">Home Page</a>
            </b>
        </div>
    );
};

export default NotFound;
